import script from "./DocumentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentPage.vue?vue&type=style&index=0&id=0c63cd83&lang=scss&scoped=true"
import "./DocumentPage.vue?vue&type=style&index=1&id=0c63cd83&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c63cd83"]])

export default __exports__